export const EXAM_COMMON_PAGE_PATHS = {
  changePassword: "/change-password",
} as const;

export const EXAM_ADMIN_PAGE_PATHS = {
  dashboard: "/dashboard",
  exams: "/exams",
} as const;

export const EXAM_CANDIDATE_PAGE_PATHS = {
  entry: "/entry",
  exams: "/exams",
  profile: "/profile",
  attempts: "/attempts",
} as const;

function encodePagePathSegment(value: string | number) {
  return encodeURIComponent(String(value));
}

export function buildExamCandidateExamEntryPath(entryCode: string) {
  return `${EXAM_CANDIDATE_PAGE_PATHS.entry}/${encodePagePathSegment(entryCode)}`;
}

export function buildExamCandidateExamDetailPath(examCode: string) {
  return `${EXAM_CANDIDATE_PAGE_PATHS.exams}/${encodePagePathSegment(examCode)}`;
}

export function buildExamCandidateAttemptPath(attemptNo: string) {
  return `${EXAM_CANDIDATE_PAGE_PATHS.attempts}/${encodePagePathSegment(attemptNo)}`;
}

export function buildExamCandidateAttemptResultPath(attemptNo: string) {
  return `${EXAM_CANDIDATE_PAGE_PATHS.attempts}/${encodePagePathSegment(attemptNo)}/result`;
}
